module.exports = __webpack_public_path__ + "img/point-red-white.d7048e2f.png";